export default __webpack_public_path__ + "static/media/MoodySky.5425be75.JPG";